import * as commonConsts from '../../pages/common/CommonConsts';
import moment from 'moment';
import { getApplicationDetails } from './Helper';
import {
  getNewIndividualTrader,
  getDuplicateAddressDetail,
  getNewOrganisation,
  getNewIndividualAccountant,
  getNewOrganisationAccountant,
  getNewLeadAuditor
} from '../../utils/Helper';
const formattedIndividualNewApplicationJson = (application, newApplicationDetail, twoFA) => {
  const {
    individualAuthorityHolder,
    individualLicence,
    duration,
    fundraisingDetail,
    trader,
    branch,
    accountant
  } = newApplicationDetail;
  const { data } = twoFA;
  const { newTraders } = trader;
  const { newBranches } = branch;
  const { auditors } = accountant;

  const applicationDetails = getApplicationDetails(individualLicence, twoFA, individualAuthorityHolder);

  let associatedIndividuals = [];
  let associatedOrganisations = [];

  // construct premises addresses if auth holder address is used
  const constructNewPremistAddress = (authorityHolderAdresses, existingAuthorityHolderAdresses) => {
    let newAddresses = [];

    existingAuthorityHolderAdresses = existingAuthorityHolderAdresses.filter(
      (a) => a.addressType === commonConsts.ResidentialAddressType || a.addressType === commonConsts.PostalAddressType
    );

    authorityHolderAdresses.forEach(function (a) {
      let newAddress = a;

      const existingAuthorityHolderAddress = existingAuthorityHolderAdresses.find(
        (ea) => ea.addressType === a.addressType
      );

      if (existingAuthorityHolderAddress && a.addressNotChanged === true) {
        newAddress = {
          addressNotChanged: false,
          addressType: a.addressType,
          details: {
            Status: 'Success',
            Address: {
              addressLine1: existingAuthorityHolderAddress.addressLine,
              suburb: existingAuthorityHolderAddress.suburb,
              state: existingAuthorityHolderAddress.state,
              postcode: existingAuthorityHolderAddress.postCode,
              country: existingAuthorityHolderAddress.country,
              streetName: existingAuthorityHolderAddress.streetName
            }
          }
        };
        newAddresses.push(newAddress);
        return;
      }

      newAddresses.push(newAddress);
    });

    const residentialAddress = newAddresses.find((a) => a.addressType === commonConsts.ResidentialAddressType);
    const registeredAddress = {
      ...residentialAddress,
      addressType: commonConsts.RegisteredAddressType
    };
    newAddresses.push(registeredAddress);

    return newAddresses;
  };

  if (trader.engageNewTrader) {
    //#region "Individual Trader"

    associatedIndividuals = newTraders
      .filter((x) => x.type.toLowerCase() === commonConsts.OptionsIndividual)
      .map(getNewIndividualTrader);

    //#endregion

    //#region "Organisation Trader"

    associatedOrganisations = newTraders
      .filter((x) => x.type.toLowerCase() === commonConsts.OptionsOrganisation && !x.orgDataInfo?.data?.siebelRowId)
      .map((t) => {
        return getNewOrganisation(t, 'Trader');
      });

    associatedOrganisations = associatedOrganisations.concat(
      newTraders
        .filter((x) => x.type.toLowerCase() === commonConsts.OptionsOrganisation && x.orgDataInfo?.data?.siebelRowId)
        .map((trader) => {
          return {
            id: trader?.orgDataInfo?.data.siebelRowId,
            name: trader?.organisationName,
            abn: trader?.orgDataInfo?.data?.abn,
            acn: trader?.orgDataInfo?.data?.acn,
            roles: [],
            roleDetails: [
              {
                RoleType: 'Trader',
                StartDate: trader.startDate
              }
            ]
          };
        })
    );
    //#endregion
  }

  //#region Accountants

  associatedIndividuals = associatedIndividuals.concat(
    auditors
      .filter((x) => x.partyType.toLowerCase() === commonConsts.OptionsIndividual.toLowerCase())
      .map((a) => {
        return getNewIndividualAccountant(a, '');
      })
  );

  auditors
    .filter((x) => x.partyType.toLowerCase() === commonConsts.OptionsOrganisation.toLowerCase())
    .map((a) => {
      associatedIndividuals = associatedIndividuals.concat(getNewLeadAuditor(a));

      associatedOrganisations = associatedOrganisations.concat(getNewOrganisationAccountant(a));
    });

  //#endregion

  //#region "Organisation Branch"

  associatedOrganisations = associatedOrganisations.concat(
    newBranches
      .filter((x) => x.type.toLowerCase() === commonConsts.OptionsOrganisation && !x.orgDataInfo?.data?.siebelRowId)
      .map((b) => {
        return getNewOrganisation(b, 'Sub-Branch');
      })
  );

  associatedOrganisations = associatedOrganisations.concat(
    newBranches
      .filter((x) => x.type.toLowerCase() === commonConsts.OptionsOrganisation && x.orgDataInfo?.data?.siebelRowId)
      .map((branch) => {
        return {
          id: branch?.orgDataInfo?.data.siebelRowId,
          roles: [],
          roleDetails: [
            {
              RoleType: 'Sub-Branch',
              StartDate: trader.startDate
            }
          ]
        };
      })
  );
  //#endregion

  const authorityHolderAdresses = getDuplicateAddressDetail(
    applicationDetails?.residentialAddress,
    applicationDetails?.postalAddress
  );

  let result = {
    applicationId: application.applicationId,
    licenceType: 'Charitable Fundraising',
    applicationNo: application.applicationNo,
    applicationType: 'new-application',
    applicantType: 'Individual',
    durationRequested: duration.detail,
    associatedIndividuals: associatedIndividuals,
    associatedOrganisations: associatedOrganisations,
    fundRaisingDetail: {
      charityObjects: fundraisingDetail.charityObject,
      natureDuration: fundraisingDetail.natureDuration,
      financialYearEnd: `${fundraisingDetail.day}/${fundraisingDetail.month}`,
      directorRemuneration: fundraisingDetail.directorRemuneration,
      applicantOrgType: fundraisingDetail.applicantOrgType,
      // parentOrganisation: newApplicationDetail.charitableObject.parentOrg,
      charityWebsiteUrl: fundraisingDetail.charityWebsiteUrl
    },
    individualApplicantDetails: {
      roles: ['Applicant'],
      id: applicationDetails.partyRowId,
      firstName: applicationDetails.firstName,
      middleName: applicationDetails.middleName,
      surname: applicationDetails.lastName,
      dateofbirth: applicationDetails.dateOfBirth ? moment(applicationDetails.dateOfBirth).format('DD/MM/YYYY') : null,
      placeOfBirth: null,
      twoFaVerified: data ? true : false,
      hasOtherNames: false,
      otherNames: null,
      identificationDetails: null,
      contactPart: {
        emailAddress: applicationDetails.emailAddress,
        mobileNo: applicationDetails.mobile,
        phoneNo:
          applicationDetails?.secondaryContact?.prefix && applicationDetails?.secondaryContact?.number
            ? `${applicationDetails.secondaryContact.prefix}-${applicationDetails.secondaryContact.number}`
            : null
      },
      addresses: authorityHolderAdresses
    },
    // authorityHolderExistingAddresses: [
    //   {
    //     addressType: 'Residential',
    //     address: applicationDetails?.residentialAddressExisting
    //   },
    //   {
    //     addressType: 'Postal',
    //     address: applicationDetails?.postalAddressExisting
    //   }
    // ]
    premisesList: [
      {
        businessName: applicationDetails.authorityHolderName,
        roles: [commonConsts.RegisteredAddressType],
        premiseAddresses: !!!data
          ? authorityHolderAdresses
          : constructNewPremistAddress(authorityHolderAdresses, data.addressses)
      }
    ]
  };

  return result;
};

export { formattedIndividualNewApplicationJson };
